export default __webpack_public_path__ + "static/media/JUDYS_BOOK.56254ffa.png";